// removed by extract-text-webpack-plugin
module.exports = {"backgroundColorTransitionTime":"1500ms","highlightColor":"#e0fbe0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/schedule/schedule-item/schedule-item.css
// module id = 636
// module chunks = 0